
import { HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from '../services/local-storage.service';

const ls = new LocalStorageService();

export const clientHeaders = new HttpHeaders({
	'Access-Control-Allow-Origin': window.location.origin,
	Authorization: `Bearer ${ls.getItem('bearer')}`
});
